import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Markdown from "@sprout/client-components/dist/Markdown";
import Head from "@sprout/client-layout/dist/Head";
import { LandingFooter, LandingSectionMaxWidth } from "sprout-ui-dom/dist/Landing";
import __html from "../../markdown/amendment.md";
const AmendmentPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: "Sprout"
            }),
            /*#__PURE__*/ _jsx(LandingSectionMaxWidth, {
                children: /*#__PURE__*/ _jsx(Markdown, {
                    dangerouslySetInnerHTML: {
                        __html
                    }
                })
            }),
            /*#__PURE__*/ _jsx(LandingFooter, {})
        ]
    });
};
export default AmendmentPage;
